<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MX532, MX632, XM3350 daugiafunkciai spausdintuvai">
     MX532, MX632, XM3350 daugiafunkciai spausdintuvai
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_lt" title="Saugos informacija">
     Saugos informacija
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Sutartiniai žymenys">
      Sutartiniai žymenys
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Parei&scaron;kimai dėl gaminio">
      Parei&scaron;kimai dėl gaminio
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_lt" title="Žinios apie spausdintuvą">
     Žinios apie spausdintuvą
    </a>
   </p>
   <div id="divd0e175">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_lt" title="Informacijos apie spausdintuvą paie&scaron;ka">
      Informacijos apie spausdintuvą paie&scaron;ka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_lt" title="Spausdintuvo serijos numerio paie&scaron;ka">
      Spausdintuvo serijos numerio paie&scaron;ka
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_lt" title="Spausdintuvo konfigūracijos">
      Spausdintuvo konfigūracijos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_lt" title="Valdymo skydelio naudojimas">
      Valdymo skydelio naudojimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_lt" title="Kaip suprasti indikatoriaus lemputės spalvas">
      Kaip suprasti indikatoriaus lemputės spalvas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e500" title="Popieriaus parinkimas">
      Popieriaus parinkimas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_lt" title="Nustatymas, įrengimas ir konfigūravimas">
     Nustatymas, įrengimas ir konfigūravimas
    </a>
   </p>
   <div id="divd0e1569">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_lt" title="Vietos spausdintuvui parinkimas">
      Vietos spausdintuvui parinkimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_lt" title="Laidų ir kabelių prijungimas">
      Laidų ir kabelių prijungimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e1764" title="Pradžios ekrano programų diegimas ir naudojimas">
      Pradžios ekrano programų diegimas ir naudojimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e2411" title="Prieinamumo funkcijų nustatymas ir naudojimas">
      Prieinamumo funkcijų nustatymas ir naudojimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e2717" title="Fakso nustatymas spausdintuve">
      Fakso nustatymas spausdintuve
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_lt" title="El. pa&scaron;to SMTP nustatymų konfigūravimas">
      El. pa&scaron;to SMTP nustatymų konfigūravimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e4576" title="Popieriaus ir specialiųjų laikmenų įdėjimas">
      Popieriaus ir specialiųjų laikmenų įdėjimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e4744" title="Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas">
      Programinės ir programinės aparatinės įrangos bei tvarkyklių diegimas ir atnaujinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e5025" title="Papildomos aparatinės įrangos įrengimas">
      Papildomos aparatinės įrangos įrengimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="wireless-support-topic.html#d0e5334" title="Prijungimas prie tinklo">
      Prijungimas prie tinklo
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_lt" title="Spausdintuvo apsaugojimas">
     Spausdintuvo apsaugojimas
    </a>
   </p>
   <div id="divd0e5759">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_lt" title="Saugos lizdo vietos nustatymas">
      Saugos lizdo vietos nustatymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_lt" title="Spausdintuvo atminties i&scaron;valymas">
      Spausdintuvo atminties i&scaron;valymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_lt" title="Spausdintuvo atminties įrenginio i&scaron;valymas">
      Spausdintuvo atminties įrenginio i&scaron;valymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_lt" title="Gamyklinių numatytųjų nustatymų atkūrimas">
      Gamyklinių numatytųjų nustatymų atkūrimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_lt" title="Parei&scaron;kimas dėl nei&scaron;liekamosios atminties įtaisų">
      Parei&scaron;kimas dėl nei&scaron;liekamosios atminties įtaisų
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_lt" title="Spausdinimas">
     Spausdinimas
    </a>
   </p>
   <div id="divd0e5952">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_lt" title="Spausdinimas i&scaron; kompiuterio">
      Spausdinimas i&scaron; kompiuterio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e5978" title="Spausdinimas i&scaron; mobiliojo prietaiso">
      Spausdinimas i&scaron; mobiliojo prietaiso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_lt" title="Spausdinimas i&scaron; atmintuko">
      Spausdinimas i&scaron; atmintuko
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_lt" title="Palaikomi atmintukai ir failų tipai">
      Palaikomi atmintukai ir failų tipai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_lt" title="Konfidencialių užduočių konfigūravimas">
      Konfidencialių užduočių konfigūravimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_lt" title="Konfidencialių ir kitų turimų užduočių spausdinimas">
      Konfidencialių ir kitų turimų užduočių spausdinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_lt" title="&Scaron;riftų pavyzdžių sąra&scaron;o spausdinimas">
      &Scaron;riftų pavyzdžių sąra&scaron;o spausdinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_lt" title="Katalogo sąra&scaron;o spausdinimas">
      Katalogo sąra&scaron;o spausdinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_lt" title="Skiriamųjų lapų dėjimas tarp kopijų">
      Skiriamųjų lapų dėjimas tarp kopijų
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_lt" title="Spausdinimo užduoties at&scaron;aukimas">
      Spausdinimo užduoties at&scaron;aukimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_lt" title="Dažų tamsumo koregavimas">
      Dažų tamsumo koregavimas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_lt" title="Kopijavimas">
     Kopijavimas
    </a>
   </p>
   <div id="divd0e6568">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_lt" title="Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas">
      Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_lt" title="Kopijų darymas">
      Kopijų darymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_lt" title="Nuotraukų kopijavimas">
      Nuotraukų kopijavimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_lt" title="Kopijavimas ant firminių blankų">
      Kopijavimas ant firminių blankų
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_lt" title="Kopijavimas ant abiejų popieriaus pusių">
      Kopijavimas ant abiejų popieriaus pusių
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_lt" title="Kopijų mažinimas arba didinimas">
      Kopijų mažinimas arba didinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_lt" title="Kopijų sudėstymas">
      Kopijų sudėstymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_lt" title="Skiriamųjų lapų dėjimas tarp kopijų">
      Skiriamųjų lapų dėjimas tarp kopijų
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_lt" title="Kelių puslapių kopijavimas viename lape">
      Kelių puslapių kopijavimas viename lape
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_lt" title="Kortelių kopijavimas">
      Kortelių kopijavimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_lt" title="Sparčiosios kopijavimo nuorodos kūrimas">
      Sparčiosios kopijavimo nuorodos kūrimas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_lt" title="El. pa&scaron;tas">
     El. pa&scaron;tas
    </a>
   </p>
   <div id="divd0e6879">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_lt" title="Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas">
      Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_lt" title="Elektroninio lai&scaron;ko siuntimas">
      Elektroninio lai&scaron;ko siuntimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_lt" title="El. pa&scaron;to sparčiosios nuorodos kūrimas">
      El. pa&scaron;to sparčiosios nuorodos kūrimas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_lt" title="Faksas">
     Faksas
    </a>
   </p>
   <div id="divd0e6973">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_lt" title="Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas">
      Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_lt" title="Faksogramos siuntimas">
      Faksogramos siuntimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_lt" title="Faksogramos siuntimo planavimas">
      Faksogramos siuntimo planavimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_lt" title="Faksogramų paskirties vietos sparčiosios nuorodos kūrimas">
      Faksogramų paskirties vietos sparčiosios nuorodos kūrimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_lt" title="Faksogramos skiriamosios gebos keitimas">
      Faksogramos skiriamosios gebos keitimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_lt" title="Faksogramos tamsumo koregavimas">
      Faksogramos tamsumo koregavimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_lt" title="Faksogramų žurnalo spausdinimas">
      Faksogramų žurnalo spausdinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_lt" title="Brukalo faksogramų blokavimas">
      Brukalo faksogramų blokavimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_lt" title="Faksogramų užlaikymas">
      Faksogramų užlaikymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_lt" title="Faksogramos persiuntimas">
      Faksogramos persiuntimas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_lt" title="Skenavimas">
     Skenavimas
    </a>
   </p>
   <div id="divd0e7338">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_lt" title="Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas">
      Automatinio dokumentų tiektuvo ir skenerio stiklo naudojimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_lt" title="Skenavimas į kompiuterį">
      Skenavimas į kompiuterį
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_lt" title="Nuskaitymas į FTP serverį">
      Nuskaitymas į FTP serverį
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_lt" title="Sparčiosios FTP nuorodos kūrimas">
      Sparčiosios FTP nuorodos kūrimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_lt" title="Nuskaitymas į tinklo aplanką">
      Nuskaitymas į tinklo aplanką
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_lt" title="Tinklo aplanko sparčiosios nuorodos kūrimas">
      Tinklo aplanko sparčiosios nuorodos kūrimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_lt" title="Skenavimas į atmintuką">
      Skenavimas į atmintuką
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_lt" title="Kaip naudoti spausdintuvo meniu">
     Kaip naudoti spausdintuvo meniu
    </a>
   </p>
   <div id="divd0e7640">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menu-map-mfp_lt" title="Meniu planas">
      Meniu planas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e8021" title="Įrenginys">
      Įrenginys
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e10356" title="Spausdinimas">
      Spausdinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e11519" title="Popierius">
      Popierius
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e11879" title="Kopijavimas">
      Kopijavimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e12451" title="Faksas">
      Faksas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e14879" title="El. pa&scaron;tas">
      El. pa&scaron;tas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e15895" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e16541" title="USB atmintukas">
      USB atmintukas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e17342" title="Tinklas / prievadai">
      Tinklas / prievadai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e19486" title="Saugumas">
      Saugumas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e20636" title="Debesų paslaugos">
      Debesų paslaugos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e20693" title="Ataskaitos">
      Ataskaitos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_lt" title="Trikčių &scaron;alinimas">
      Trikčių &scaron;alinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_lt" title="&bdquo;Forms Merge&ldquo;">
      &bdquo;Forms Merge&ldquo;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_lt" title="Meniu nustatymų puslapio spausdinimas">
      Meniu nustatymų puslapio spausdinimas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_lt" title="Spausdintuvo priežiūra">
     Spausdintuvo priežiūra
    </a>
   </p>
   <div id="divd0e21237">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_lt" title="Dalių ir eksploatacinių medžiagų būsenos tikrinimas">
      Dalių ir eksploatacinių medžiagų būsenos tikrinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_lt" title="Prane&scaron;imų dėl eksploatacinių medžiagų konfigūravimas">
      Prane&scaron;imų dėl eksploatacinių medžiagų konfigūravimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_lt" title="Įspėjimų el. pa&scaron;tu nustatymas">
      Įspėjimų el. pa&scaron;tu nustatymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_lt" title="Ataskaitų peržiūra">
      Ataskaitų peržiūra
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_lt" title="Dalių ir eksploatacinių reikmenų užsakymas">
      Dalių ir eksploatacinių reikmenų užsakymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e21570" title="Dalių ir eksploatacinių reikmenų keitimas">
      Dalių ir eksploatacinių reikmenų keitimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e21913" title="Spausdintuvo dalių valymas">
      Spausdintuvo dalių valymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e22060" title="Elektros energijos ir popieriaus taupymas">
      Elektros energijos ir popieriaus taupymas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_lt" title="Spausdintuvo perkėlimas į kitą vietą">
      Spausdintuvo perkėlimas į kitą vietą
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_lt" title="Spausdintuvo transportavimas">
      Spausdintuvo transportavimas
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_lt" title="Trikties &scaron;alinimas">
     Trikties &scaron;alinimas
    </a>
   </p>
   <div id="divd0e22214">
    <p class="toc-2-style">
     <a href="print-quality-problems-picker-topic.html#print-quality-problems-picker_lt" title="Spausdinimo kokybės problemos">
      Spausdinimo kokybės problemos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_lt" title="Spausdintuvo klaidų kodai">
      Spausdintuvo klaidų kodai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_lt" title="Spausdinimo problemos">
      Spausdinimo problemos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_lt" title="Spausdintuvas nereaguoja">
      Spausdintuvas nereaguoja
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_lt" title="Nepavyksta nuskaityti atmintuko">
      Nepavyksta nuskaityti atmintuko
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_lt" title="USB jungties įgalinimas">
      USB jungties įgalinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_lt" title="Strigčių &scaron;alinimas">
      Strigčių &scaron;alinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e25885" title="Tinklo ry&scaron;io problemos">
      Tinklo ry&scaron;io problemos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e26113" title="Papildomos aparatinės įrangos problemos">
      Papildomos aparatinės įrangos problemos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e26261" title="Problemos, susijusios su eksploataciniais reikmenimis">
      Problemos, susijusios su eksploataciniais reikmenimis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e26384" title="Popieriaus tiekimo problemos">
      Popieriaus tiekimo problemos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e26750" title="Problemos siunčiant el. pa&scaron;tu">
      Problemos siunčiant el. pa&scaron;tu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e26844" title="Problemos siunčiant faksu">
      Problemos siunčiant faksu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e27489" title="Skenavimo problemos">
      Skenavimo problemos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_lt" title="Kreipimasis į klientų aptarnavimo skyrių">
      Kreipimasis į klientų aptarnavimo skyrių
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_lt" title="Perdirbimas ir &scaron;alinimas">
     Perdirbimas ir &scaron;alinimas
    </a>
   </p>
   <div id="divd0e28269">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_lt" title="&bdquo;Lexmark&ldquo; gaminių perdirbimas">
      &bdquo;Lexmark&ldquo; gaminių perdirbimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_lt" title="Perdirbamos &bdquo;Lexmark&ldquo; pakuotės">
      Perdirbamos &bdquo;Lexmark&ldquo; pakuotės
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_lt" title="Prane&scaron;imai">
     Prane&scaron;imai
    </a>
   </p>
   <div id="divd0e28306">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28309" title="Gaminio informacija">
      Gaminio informacija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28326" title="Prane&scaron;imas apie leidimą">
      Prane&scaron;imas apie leidimą
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_lt" title="Prekių ženklai">
      Prekių ženklai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_lt" title="Licencijavimo prane&scaron;imai">
      Licencijavimo prane&scaron;imai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_lt" title="Triuk&scaron;mo lygiai">
      Triuk&scaron;mo lygiai
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_lt" title="Direktyva dėl elektros ir elektroninės įrangos atliekų (EEIĄ direktyva)">
      Direktyva dėl elektros ir elektroninės įrangos atliekų (EEIĄ direktyva)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28432" title="Pakartotinai įkraunama ličio jonų baterija">
      Pakartotinai įkraunama ličio jonų baterija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_lt" title="Reglamentas (ES) 2023/1542">
      Reglamentas (ES) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28470" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_lt" title="Gaminio &scaron;alinimas">
      Gaminio &scaron;alinimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_lt" title="&bdquo;Lexmark&ldquo; kasečių grąžinimas pakartotiniam naudojimui arba perdirbimui">
      &bdquo;Lexmark&ldquo; kasečių grąžinimas pakartotiniam naudojimui arba perdirbimui
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_lt" title="Prane&scaron;imas dėl statinio elektros krūvio poveikio">
      Prane&scaron;imas dėl statinio elektros krūvio poveikio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_lt" title="&bdquo;ENERGY STAR&ldquo;">
      &bdquo;ENERGY STAR&ldquo;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_lt" title="Temperatūros duomenys">
      Temperatūros duomenys
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_lt" title="Prane&scaron;imas dėl lazerio">
      Prane&scaron;imas dėl lazerio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_lt" title="Elektros energijos suvartojimas">
      Elektros energijos suvartojimas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_lt" title="Reglamentiniai prane&scaron;imai dėl galinių telekomunikacijų įrenginių">
      Reglamentiniai prane&scaron;imai dėl galinių telekomunikacijų įrenginių
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28734" title="Reglamentavimo prane&scaron;imai dėl belaidžio ry&scaron;io įrenginių">
      Reglamentavimo prane&scaron;imai dėl belaidžio ry&scaron;io įrenginių
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_lt" title="Prane&scaron;imas dėl modulinių komponentų">
      Prane&scaron;imas dėl modulinių komponentų
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_lt" title="Radijo dažnių spinduliuotės poveikis">
      Radijo dažnių spinduliuotės poveikis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28759" title="Atitiktis Europos Bendrijos (EB) direktyvoms">
      Atitiktis Europos Bendrijos (EB) direktyvoms
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_lt" title="Atitiktis Europos Bendrijos (EB) direktyvoms">
      Atitiktis Europos Bendrijos (EB) direktyvoms
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_lt" title="Prane&scaron;imas dėl radijo trukdžių">
      Prane&scaron;imas dėl radijo trukdžių
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue